import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { env } from '../lib/config/env'
import { getLanguageFromStorage } from '../lib/getLanguageFromStorage'
import {
    COMPETITOR_STATS_TAG,
    MATCH_STATS_TAG,
    PARTICIPANT_MATCHES_TAG,
    PARTICIPANT_RACES_TAG,
} from './tags'

export const fetchApi = createApi({
    reducerPath: 'fetchApi',
    baseQuery: fetchBaseQuery({
        baseUrl: env.statsApiUrl,
        prepareHeaders: (headers) => {
            headers.set('Accept-Language', getLanguageFromStorage())
            return headers
        },
    }),
    tagTypes: [
        COMPETITOR_STATS_TAG,
        PARTICIPANT_MATCHES_TAG,
        PARTICIPANT_RACES_TAG,
        MATCH_STATS_TAG,
    ],
    endpoints: () => ({}),
})
